import * as React from "react";
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../common/modalDialog';
import { Button } from "primereact/button";
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import InteractionsService from '../../services/interactionsService';
import { ProfessionType, PregnancyType } from '../../common/enums';
import * as HelperFunctions from '../../common/functions/helperFunctions';

interface IProps {
  isVisible: boolean;
  closeClick: any;
  medicineId: number;
  pregnancyType: boolean;
  medicineName: string;
  lang: string
}

interface IState {
  isLoading: boolean;
  error: any;
  tabActiveIndex: number;
  interactionDescription: string;
}

class InteractionDrugToPregnancyDialog extends React.Component<IProps, IState> {

  interactionsService = new InteractionsService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      error: null,
      isLoading: false,
      tabActiveIndex: 0,
      interactionDescription: ''
    };
  }

  componentDidMount() {
    this.getInteractionDescription();
  }

  getInteractionDescription() {
    this.setState({
      isLoading: true
    });

    const { medicineId, pregnancyType } = this.props;

    this.interactionsService.getDrugToPregnancyInteraction(medicineId, pregnancyType, this.props.lang).then(
      (data: string) => {
        this.setState({
          isLoading: false,
          interactionDescription: data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleCloseButton = () => {
    this.props.closeClick();
  }

  public render() {
    const { isLoading, error, tabActiveIndex, interactionDescription } = this.state;
    const { pregnancyType, medicineName } = this.props;

    return (
      <Dialog
        open={this.props.isVisible}
        onClose={this.handleCloseButton}
        fullWidth
      >
        <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCloseButton}>{Translate('Interactions')}</Modal.DialogTitle>
        <Modal.DialogContent>
          <div style={{ minHeight: '500px', maxHeight: '500px', overflowY: 'auto' }}>

            {isLoading ? <Spinner /> : null}
            {error && error.message ? <AlertMessage type='danger'>{error.message}</AlertMessage> : null}

            <h4 style={{ marginBottom: "20px", marginTop: "10px" }}>
              {medicineName} ↔ {pregnancyType == true ? Translate("Pregnancy and Breastfeeding") : null}
            </h4>

            <p dangerouslySetInnerHTML={{ __html: interactionDescription }}></p>

          </div>
        </Modal.DialogContent>
        <Modal.DialogActions>
          <div>
            <Button label={Translate('Close')} icon="pi pi-check" onClick={this.handleCloseButton} className="p-button-raised" />
          </div>
        </Modal.DialogActions>
      </Dialog>
    )
  }
}

export default InteractionDrugToPregnancyDialog;